// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"193":"23c73953","616":"a0597257"}[chunkId] + ".chunk.js");